import Helper from '@/common/helper'

export function buildStripPaymentClientParams (planId) {
  const params = {
    planId
  }
  const deviceId = Helper.getCookie('deviceId')
  if (deviceId) {
    params.deviceId = deviceId.toLowerCase()
  }
  return params
}
